<template>
  <div v-if="!isLoading">
    <h5>{{ datos.expoData.name }}</h5>
    <!--     <pre>
        {{datos}}
    </pre>-->
    <!--  {{datos}} -->

    <div class="row">
      <div class="col-md-12">       
          <!-- INSCRIPCIONES INDIVIDUALES - PERROS INSCRITOS -->
        <table class="table  mb-0" v-if="miTarifa.length > 0">
          <tr>
            <th colspan="2">
              {{$t('inscripciones individuales')}}
            </th>
          </tr>
          <tr v-for="(ins, index) in miTarifa" :key="index">
            <td class="text-left">
              <span class="dog-nombre">{{ ins.nombre }} ({{ ins.posicion }}) {{ ins.tarifaId }}_{{
                ins.grupoPrecio
              }}</span>
              <br />
              <div class="clase">{{ ins.clase }}</div>
            </td>
            <td class="text-right">
              {{ ins.importe.toFixed(2) | coma }}&nbsp;€
            </td>
          </tr>
        </table>

        <!-- PAREJAS -->
        <div class="row" v-if="compParejas.length > 0">
          <div class="col-12">
            <table class="table mb-0">
              <tr class="py-3">
                <th colspan="2">
                  {{ $t("parejas") }}
                </th>
              </tr>
              <tr
                v-for="(pareja, idx) in compParejas"
                :key="`${pareja.macho}_${pareja.hembra}_${idx}`"
              >
                <td class="text-left">
                  <span class="dog-nombre">{{ $t("macho") }}: {{ pareja.datos_macho.nombre }}</span><br />
                  <span class="dog-nombre">{{ $t("hembra") }}: {{ pareja.datos_hembra.nombre }}<br /></span>
                </td>
                <td class="text-right align-bottom">
                  {{ pareja | precioPareja(datos.socio) }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!-- grupo cria -->
        <div class="row" v-if="compGrupoCria.length > 0">
          <div class="col-12">
            <table class="table mb-0">
              <tr>
                <th colspan="2">
                  {{ $t("grupo cria") }}
                </th>
              </tr>
              <tr
                v-for="(grupo, idx) in compGrupoCria"
                :key="`${grupo.raza}_${grupo.criador}_${idx}`"
              >
                <td class="text-left">
                  <b>{{ razaNombre(grupo.raza) }}</b> <br />
                  <span class="dog-nombre" v-for="(d, idx) in grupo.dogs" :key="d">
                    {{ dogName(d) }} <br v-if="idx < grupo.dogs.length - 1" />
                  </span>
                </td>
                <td class="text-right align-bottom">
                  {{ grupo.importe.toFixed(2) }} €
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!-- OTROS CONCEPTOS FACTURABLES -->
        <div class="row">
          <div class="col-12">
            <table class="table">
              <tr class="py-3">
                <th colspan="2">
                  {{ $t("otros conceptos facturables") }}
                </th>
              </tr>
              <tr
                v-for="(otros, index) in datos.otrosConceptos"
                :key="`${otros.id}_${index}`"
              >
                <!--    <td>{{otros.id}}</td> -->
                <td class="text-left">
                  {{ otros.nombre }}&nbsp;({{ otros.cantidad }})
                  <br />
                  <div class="clase">
                    {{ $t("otros conceptos facturables") }}
                  </div>
                </td>
                <td class="text-right align-bottom">{{ otros.importe | coma }}&nbsp;€</td>
              </tr>
            </table>
          </div>
        </div>

        <!-- TOTAL -->
        <div class="row">
          <div class="col-12">
            <table class="table">
              <tr class="bg-danger">
                <td class="text-left">
                  <b>{{ $t("importe total") }}</b>
                </td>

                <td class="text-right">
                  <b>{{ this.importeTotal.toFixed(2) | coma }}&nbsp;€</b>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <ins-tipo-pago-comp
      :datos="datos"
      :importe="importeTotal"
      :datosNormalizados="datosNormalizados"
    ></ins-tipo-pago-comp>
    <!--  <button class="btn btn-primary" @click="$emit('emitInsertTabla')">prueba_datos</button> -->
  </div>
</template>

<script>
import InsTipoPagoComp from "@/components/layouts/inscriptions/Inscriptions-tipo-pago-comp";

export default {
  name: "ins-final-component",
  components: { InsTipoPagoComp },
  props: ["datos", "datosNormalizados"],
  data: () => ({
    isLoading: true,
    importeDogTotal: 0,
    descuentoTotal: 0,
  }),
  methods: {
    importeTotal_(dog) {
      const tarifa = this.tarifa;
      const descuentos = tarifa.descuentos;
      let importe = this.importeInscripcion;
      // tarifa.socio === 1 ? tarifa.precio.price_partner : tarifa.precio.price;

      if (descuentos.length > 0) {
        descuentos.forEach((e) => {
          const tipo = e.tipo;
          //tipo 1 importe, 2 descuento
          if (tipo === 1) {
            importe -= e.descuento;
          } else {
            importe *= 1 - e.descuento / 100;
          }
        });
      }
      if (importe < 0) {
        importe = 0;
        return importe.toFixed(2);
      } else {
        return importe.toFixed(2);
      }
    },
    clase(claseId) {
      const clases = this.datos.expoData.expo_dog_classes;
      const filtro = clases.filter((x) => {
        if (x.id === claseId) {
          return x;
        }
      });
      return filtro[0].class;
    },
    dogName(dogId) {
      const dogs = this.datos.userData.dogs;
      const filtro = dogs.filter((x) => {
        if (x.id === dogId) return x;
      });
      return filtro[0].name;
    },
    /* para recoger la raza del perro */
    razaNombre(razaId) {
      //filtramos los datos dependiendo del idioma de la page
      const lang = this.$i18n.locale;
      const perros = this.datos.expoData.breeds_all;

      const razaNombre = perros.find((p) => p.id === parseInt(razaId))
        .translations;
      const tmp = razaNombre.find((r) => r.locale === lang);

      let res = tmp.name;
      if (tmp.variety !== "") res += " " + tmp.variety;
      if (tmp.subvariety !== "") res += " " + tmp.subvariety;
      return res;
    },
  },
  computed: {
    miTarifa: function () {
      if (this.datos.inscripciones === null) {
        return null;
      }
      let salida = [];
      let importe = 0;
      this.datos.inscripciones.forEach((e) => {
        const miTarifaActual = e.tarifaId;
        e.dogs.forEach((dog) => {
          const row = {
            nombre: this.dogName(dog.id),
            clase: this.$t(this.clase(dog.clase)),
            posicion: dog.posicion,
            tarifaId: miTarifaActual,
            grupoPrecio: dog.grupoPrecio,
            importe:
              dog.socio === 1 ? dog.precio.price_partner : dog.precio.price,
          };
          importe += row.importe;
          salida.push(row);
        });
      });

      this.importeDogTotal = importe;
      return salida;
    },
    compGrupoCria() {
      return this.datos.datosGrupoCria;
    },
    compParejas() {
      return this.datos.datosParejas;
    },
    importeTotal: function () {
      const socio = this.datos.socio === 1 ? true : false;
      let importe = 0;
      if (this.miTarifa !== null) {
        //sumamos el importe de la tarifa
        this.miTarifa.forEach((e) => {
          importe += parseFloat(e.importe);
        });
        //sumamos el importe si existe de otros conceptos
        this.datos.otrosConceptos.forEach((e) => {
          importe += parseFloat(e.importe);
        });
        //parejas
        this.datos.datosParejas.forEach(p => {
          importe += socio ? p.tarifa.price_partner : p.tarifa.price;
        });
        //grupo cria
        this.datos.datosGrupoCria.forEach(p => {
          importe += p.importe;
        });
      }
      return importe;
    },
  },
  filters: {
    coma: function (value) {
      return value.replace(".", ",");
    },
    precioPareja(value, socio) {
      return socio === 1
        ? value.tarifa.price_partner.toFixed(2) + " €"
        : value.tarifa.price.toFixed(2) + " €";
    },
  },
  mounted() {
    console.log(this.datos);
    setTimeout(() => {
      this.isLoading = false;
    }, 150);
  },
};
</script>

<style scoped>
.clase {
  font-size: 0.75em;
  margin-top: 2px !important;
}
td {
  padding: 5px;
}
.dog-nombre {
  font-size:0.87em;
}
</style>
